var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DeviceAppVerifyNotSupported, StatusCodes, UserRefusedAddress } from "@ledgerhq/errors";
import { log } from "@ledgerhq/logs";
const getAddressWrapper = (getAddressFn) => (deviceId, opts) => __awaiter(void 0, void 0, void 0, function* () {
    const { currency, path, verify } = opts;
    return getAddressFn(deviceId, opts)
        .then(result => {
        log("hw", `getAddress ${currency.id} on ${path}`, result);
        return result;
    })
        .catch(e => {
        log("hw", `getAddress ${currency.id} on ${path} FAILED ${String(e)}`);
        if (e && e.name === "TransportStatusError") {
            if (e.statusCode === StatusCodes.INCORRECT_P1_P2 && verify) {
                throw new DeviceAppVerifyNotSupported();
            }
            if (e.statusCode === StatusCodes.CONDITIONS_OF_USE_NOT_SATISFIED ||
                e.statusCode === StatusCodes.USER_REFUSED_ON_DEVICE) {
                throw new UserRefusedAddress();
            }
        }
        throw e;
    });
});
export default getAddressWrapper;
//# sourceMappingURL=getAddressWrapper.js.map